<div class="card main-driver-card container-fluid">
  <p-toast />
  <p-confirmDialog />

  <!-- Header del Módulo -->
  <div class="row justify-content-between align-items-center mb-4">
    <div class="col-auto">
      <h3 class="m-0 font-bold text-muted">{{ titulo }}</h3>
      <p class="text-muted small m-0">Administración general de conductores y solicitudes de la flota</p>
    </div>
    <div class="col-auto">
      <p-button
        label="Nuevo Conductor"
        severity="primary"
        icon="pi pi-plus"
        [rounded]="true"
        size="small"
        routerLink="create"
      />
    </div>
  </div>

  <!-- Navegación de Pestañas -->
  <p-tabView>
    
    <!-- Conductores Activos -->
    <p-tabPanel header="Conductores Activos">
      <div class="mt-2">
        <p-table
          #dt1
          [value]="ltsDriver"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="p-datatable-striped p-datatable-sm"
          [paginator]="true"
          [rows]="5"
          [rowsPerPageOptions]="[5, 10, 20]"
          [globalFilterFields]="['dri_name', 'dri_last_name', 'dri_phone']"
          class="w-100"
        >
          <!-- Barra de Búsqueda y Compañía -->
          <ng-template pTemplate="caption">
            <div class="row align-items-center g-3 py-2">
              <div class="col-12 col-md-4">
                <p-dropdown
                  [(ngModel)]="companySelected"
                  [options]="ltsCompany"
                  optionLabel="com_name"
                  placeholder="Seleccione una Compañía"
                  (onChange)="getListDriver()"
                  styleClass="w-100"
                >
                  <ng-template let-company pTemplate="item">
                    {{ company.com_name }} - {{ company.pd_name }}
                  </ng-template>
                  <ng-template let-company pTemplate="selectedItem">
                    {{ company.com_name }} - {{ company.pd_name }}
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="col-12 col-md-6 d-flex align-items-center justify-content-md-end gap-2">
                <p-iconField iconPosition="left" class="w-100" style="max-width: 320px;">
                  <p-inputIcon>
                    <i class="pi pi-search"></i>
                  </p-inputIcon>
                  <input
                    #inputFindGlobal
                    pInputText
                    type="text"
                    (input)="dt1.filterGlobal(inputFindGlobal.value, 'contains')"
                    placeholder="Buscar conductor..."
                    class="w-100"
                  />
                </p-iconField>
              </div>
              <div class="col-12 col-md-2 d-flex justify-content-md-end">
                <p-button
                  [rounded]="true"
                  icon="pi pi-refresh"
                  severity="secondary"
                  [text]="true"
                  (onClick)="getListDriver()"
                  pTooltip="Actualizar Lista"
                />
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th id="tbphoto" style="width: 80px; text-align: center;">Foto</th>
              <th id="tbname">Nombre</th>
              <th id="tblastname">Apellido</th>
              <th id="tbphone">Teléfono</th>
              <th id="tbaddress">Dirección</th>
              <th id="dateregister">Fecha Registro</th>
              <th id="tbvehicle" style="text-align: center;">Vehículo Asignado</th>
              <th id="tbaction" style="width: 180px; text-align: center;">Acciones</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-driver>
            <tr>
              <td style="text-align: center;">
                <div class="driver-avatar-wrapper mx-auto">
                  @if (driver.dri_url_photo) {
                    <img [src]="driver.dri_url_photo" alt="Foto" class="driver-avatar-img" />
                  } @else {
                    <div class="driver-avatar-placeholder">
                      {{ driver.dri_name.slice(0, 1) }}
                    </div>
                  }
                </div>
              </td>
              <td class="font-bold">{{ driver.dri_name }}</td>
              <td>{{ driver.dri_last_name }}</td>
              <td>
                <i class="pi pi-phone text-muted mr-1"></i> {{ driver.dri_phone }}
              </td>
              <td>{{ driver.dri_address || 'Sin dirección' }}</td>
              <td>
                <i class="pi pi-calendar text-muted mr-1"></i> {{ driver.dri_date_creation | date: "dd-MM-yyyy" }}
              </td>
              <td style="text-align: center;">
                <span class="vehicle-badge" [ngClass]="driver.veh_plate ? 'vehicle-assigned' : 'vehicle-none'">
                  <i class="pi mr-1" [ngClass]="driver.veh_plate ? 'pi-car' : 'pi-minus-circle'"></i>
                  {{ driver.veh_plate || 'Sin Asignar' }}
                </span>
              </td>
              <td>
                <div class="action-buttons-group justify-content-center">
                  <p-button
                    icon="pi pi-file-edit"
                    [rounded]="true"
                    severity="info"
                    [text]="true"
                    pTooltip="Editar Información"
                    (onClick)="showDialog(driver)"
                  />
                  <p-button
                    icon="pi pi-info-circle"
                    [rounded]="true"
                    severity="secondary"
                    [text]="true"
                    pTooltip="Ver Detalle Completo"
                    [routerLink]="['detail', driver.dri_id]"
                  />
                  <p-button
                    icon="pi pi-sync"
                    [rounded]="true"
                    severity="success"
                    [text]="true"
                    pTooltip="Liberar Conductor"
                    (onClick)="unlockDriver($event, driver)"
                  />
                  <p-button
                    icon="pi pi-trash"
                    [rounded]="true"
                    severity="danger"
                    [text]="true"
                    pTooltip="Eliminar de la Flota"
                    (onClick)="DeleteDriver($event, driver)"
                  />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

    <!-- Conductores Pendientes -->
    <p-tabPanel header="Pendientes de Aprobación">
      <div class="mt-2">
        <p-table
          #dt2
          [value]="ltsDriverPendiente"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="p-datatable-striped p-datatable-sm"
          [paginator]="true"
          [rows]="5"
          [rowsPerPageOptions]="[5, 10, 20]"
          [globalFilterFields]="['dri_name', 'dri_last_name', 'dri_phone']"
          class="w-100"
        >
          <ng-template pTemplate="caption">
            <div class="row align-items-center g-3 py-2">
              <div class="col-12 col-md-6">
                <p-iconField iconPosition="left" class="w-100" style="max-width: 320px;">
                  <p-inputIcon>
                    <i class="pi pi-search"></i>
                  </p-inputIcon>
                  <input
                    #inputFind
                    pInputText
                    type="text"
                    (input)="dt2.filterGlobal(inputFind.value, 'contains')"
                    placeholder="Buscar conductor..."
                    class="w-100"
                  />
                </p-iconField>
              </div>
              <div class="col-12 col-md-6 d-flex justify-content-md-end">
                <p-button
                  [rounded]="true"
                  icon="pi pi-refresh"
                  severity="secondary"
                  [text]="true"
                  (onClick)="getListDriverStatus(3)"
                  pTooltip="Actualizar Lista"
                />
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th id="tbphotopending" style="width: 80px; text-align: center;">Foto</th>
              <th id="tbnamepending" style="width: 25%">
                Nombre <p-sortIcon field="dri_name" />
              </th>
              <th id="tblastnamepending" style="width: 25%">
                Apellido <p-sortIcon field="dri_last_name" />
              </th>
              <th id="tbphonepending">Teléfono</th>
              <th id="tbdateregisterpending">Fecha Registro</th>
              <th id="tbactionpending" style="width: 140px; text-align: center;">Acciones</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-driver>
            <tr>
              <td style="text-align: center;">
                <div class="driver-avatar-wrapper mx-auto">
                  @if (driver.dri_url_photo) {
                    <img [src]="driver.dri_url_photo" alt="Foto" class="driver-avatar-img" />
                  } @else {
                    <div class="driver-avatar-placeholder">
                      {{ driver.dri_name.slice(0, 1) }}
                    </div>
                  }
                </div>
              </td>
              <td class="font-bold">{{ driver.dri_name }}</td>
              <td>{{ driver.dri_last_name }}</td>
              <td>
                <i class="pi pi-phone text-muted mr-1"></i> {{ driver.dri_phone }}
              </td>
              <td>
                <i class="pi pi-calendar text-muted mr-1"></i> {{ driver.dri_date_creation | date: "dd-MM-yyyy" }}
              </td>
              <td>
                <div class="action-buttons-group justify-content-center">
                  <p-button
                    icon="pi pi-user-plus"
                    [rounded]="true"
                    severity="success"
                    [text]="true"
                    pTooltip="Aprobar y Activar"
                    (onClick)="ActivateDriver($event, driver)"
                  />
                  <p-button
                    icon="pi pi-trash"
                    [rounded]="true"
                    severity="danger"
                    [text]="true"
                    pTooltip="Rechazar y Eliminar"
                    (onClick)="DeleteDriver($event, driver)"
                  />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

    <!-- Conflicto de Placa -->
    <p-tabPanel header="Conflicto de Placa">
      <div class="mt-2">
        <p-table
          #dt4
          [value]="ltsDriverConflicto"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="p-datatable-striped p-datatable-sm"
          [paginator]="true"
          [rows]="5"
          [rowsPerPageOptions]="[5, 10, 20]"
          [globalFilterFields]="['dri_name', 'dri_last_name', 'dri_phone', 'veh_plate']"
          class="w-100"
        >
          <ng-template pTemplate="caption">
            <div class="row align-items-center g-3 py-2">
              <div class="col-12 col-md-6">
                <p-iconField iconPosition="left" class="w-100" style="max-width: 320px;">
                  <p-inputIcon>
                    <i class="pi pi-search"></i>
                  </p-inputIcon>
                  <input
                    #inputFindConflicto
                    pInputText
                    type="text"
                    (input)="dt4.filterGlobal(inputFindConflicto.value, 'contains')"
                    placeholder="Buscar conductor..."
                    class="w-100"
                  />
                </p-iconField>
              </div>
              <div class="col-12 col-md-6 d-flex justify-content-md-end">
                <p-button
                  [rounded]="true"
                  icon="pi pi-refresh"
                  severity="secondary"
                  [text]="true"
                  (onClick)="getListDriverStatus(4)"
                  pTooltip="Actualizar Lista"
                />
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th id="tbphotoconflicto" style="width: 80px; text-align: center;">Foto</th>
              <th id="tbnameconflicto">Nombre</th>
              <th id="tblastnameconflicto">Apellido</th>
              <th id="tbphoneconflicto">Teléfono</th>
              <th id="tbplateconflicto" style="text-align: center;">Placa en Conflicto</th>
              <th id="tbdateregisterconflicto">Fecha Registro</th>
              <th id="tbactionconflicto" style="width: 100px; text-align: center;">Acciones</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-driver>
            <tr>
              <td style="text-align: center;">
                <div class="driver-avatar-wrapper mx-auto">
                  @if (driver.dri_url_photo) {
                    <img [src]="driver.dri_url_photo" alt="Foto" class="driver-avatar-img" />
                  } @else {
                    <div class="driver-avatar-placeholder">
                      {{ driver.dri_name.slice(0, 1) }}
                    </div>
                  }
                </div>
              </td>
              <td class="font-bold">{{ driver.dri_name }}</td>
              <td>{{ driver.dri_last_name }}</td>
              <td>
                <i class="pi pi-phone text-muted mr-1"></i> {{ driver.dri_phone }}
              </td>
              <td style="text-align: center;">
                <span class="vehicle-badge vehicle-assigned">
                  <i class="pi pi-car mr-1"></i> {{ driver.veh_plate }}
                </span>
              </td>
              <td>
                <i class="pi pi-calendar text-muted mr-1"></i> {{ driver.dri_date_creation | date: "dd-MM-yyyy" }}
              </td>
              <td>
                <div class="action-buttons-group justify-content-center">
                  <p-button
                    icon="pi pi-trash"
                    [rounded]="true"
                    severity="danger"
                    [text]="true"
                    pTooltip="Eliminar definitivamente"
                    (onClick)="DeleteDriverPendingVehicle($event, driver)"
                  />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

    <!-- Conductores Eliminados -->
    <p-tabPanel header="Conductores Eliminados">
      <div class="mt-2">
        <p-table
          #dt3
          [value]="ltsDriverDelete"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="p-datatable-striped p-datatable-sm"
          [paginator]="true"
          [rows]="5"
          [rowsPerPageOptions]="[5, 10, 20]"
          [globalFilterFields]="['dri_name', 'dri_last_name', 'dri_phone']"
          class="w-100"
        >
          <ng-template pTemplate="caption">
            <div class="row align-items-center g-3 py-2">
              <div class="col-12 col-md-6">
                <p-iconField iconPosition="left" class="w-100" style="max-width: 320px;">
                  <p-inputIcon>
                    <i class="pi pi-search"></i>
                  </p-inputIcon>
                  <input
                    #inputFindDelete
                    pInputText
                    type="text"
                    (input)="dt3.filterGlobal(inputFindDelete.value, 'contains')"
                    placeholder="Buscar conductor..."
                    class="w-100"
                  />
                </p-iconField>
              </div>
              <div class="col-12 col-md-6 d-flex justify-content-md-end">
                <p-button
                  [rounded]="true"
                  icon="pi pi-refresh"
                  severity="secondary"
                  [text]="true"
                  (onClick)="getListDriverStatus(0)"
                  pTooltip="Actualizar Lista"
                />
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th id="tbphotodelete" style="width: 80px; text-align: center;">Foto</th>
              <th id="tbnamedelete">Nombre</th>
              <th id="tblastnamedelete">Apellido</th>
              <th id="tbphonedelete">Teléfono</th>
              <th id="tbdateregisterdelete">Fecha Registro</th>
              <th id="tbactiondelete" style="width: 140px; text-align: center;">Acciones</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-driver>
            <tr>
              <td style="text-align: center;">
                <div class="driver-avatar-wrapper mx-auto">
                  @if (driver.dri_url_photo) {
                    <img [src]="driver.dri_url_photo" alt="Foto" class="driver-avatar-img" />
                  } @else {
                    <div class="driver-avatar-placeholder">
                      {{ driver.dri_name.slice(0, 1) }}
                    </div>
                  }
                </div>
              </td>
              <td class="font-bold">{{ driver.dri_name }}</td>
              <td>{{ driver.dri_last_name }}</td>
              <td>
                <i class="pi pi-phone text-muted mr-1"></i> {{ driver.dri_phone }}
              </td>
              <td>
                <i class="pi pi-calendar text-muted mr-1"></i> {{ driver.dri_date_creation | date: "dd-MM-yyyy" }}
              </td>
              <td>
                <div class="action-buttons-group justify-content-center">
                  <p-button
                    icon="pi pi-user-plus"
                    [rounded]="true"
                    severity="success"
                    [text]="true"
                    pTooltip="Restaurar y Activar"
                    (onClick)="ActivateDriver($event, driver)"
                  />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<!-- Diálogo de Edición Rápida -->
<p-dialog
  header="Editar Información del Conductor"
  [modal]="true"
  [(visible)]="dialogEdit"
  [style]="{ width: '450px' }"
  [breakpoints]="{ '640px': '90vw' }"
>
  <span class="p-text-secondary d-block mb-4">Actualice los datos personales y de acceso del conductor.</span>
  
  <form (ngSubmit)="save()" [formGroup]="formConductor" class="p-fluid">
    
    <!-- Nombre -->
    <div class="mb-3">
      <label for="dri_name" class="form-label-edit d-block mb-2">Nombre *</label>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <i class="pi pi-user"></i>
        </span>
        <input
          id="dri_name"
          type="text"
          pInputText
          formControlName="dri_name"
          placeholder="Nombres"
          class="largeInput"
        />
      </div>
      @if (
        formConductor.controls["dri_name"].hasError("required") &&
        formConductor.controls["dri_name"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Campo Requerido</span>
      }
    </div>

    <!-- Apellido -->
    <div class="mb-3">
      <label for="dri_last_name" class="form-label-edit d-block mb-2">Apellido *</label>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <i class="pi pi-user"></i>
        </span>
        <input
          id="dri_last_name"
          type="text"
          pInputText
          formControlName="dri_last_name"
          placeholder="Apellidos"
          class="largeInput"
        />
      </div>
      @if (
        formConductor.controls["dri_last_name"].hasError("required") &&
        formConductor.controls["dri_last_name"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Campo Requerido</span>
      }
      @if (
        formConductor.controls["dri_last_name"].hasError("pattern") &&
        formConductor.controls["dri_last_name"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Solo se aceptan números. (Código postal/id auxiliar)</span>
      }
    </div>

    <!-- Teléfono -->
    <div class="mb-3">
      <label for="dri_phone" class="form-label-edit d-block mb-2">Teléfono *</label>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <i class="pi pi-phone"></i>
        </span>
        <input
          id="dri_phone"
          type="text"
          pInputText
          formControlName="dri_phone"
          placeholder="Número telefónico"
          class="largeInput"
        />
      </div>
      @if (
        formConductor.controls["dri_phone"].hasError("required") &&
        formConductor.controls["dri_phone"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Campo Requerido</span>
      }
      @if (
        formConductor.controls["dri_phone"].hasError("pattern") &&
        formConductor.controls["dri_phone"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Solo se permiten números.</span>
      }
    </div>

    <!-- Nro. Licencia -->
    <div class="mb-3">
      <label for="dri_number_license" class="form-label-edit d-block mb-2">Nro. Licencia *</label>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <i class="pi pi-id-card"></i>
        </span>
        <input
          id="dri_number_license"
          type="text"
          pInputText
          formControlName="dri_number_license"
          placeholder="Número de licencia"
          class="largeInput"
        />
      </div>
      @if (
        formConductor.controls["dri_number_license"].hasError("required") &&
        formConductor.controls["dri_number_license"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Campo Requerido</span>
      }
    </div>

    <!-- Nro. social / Identificación -->
    <div class="mb-3">
      <label for="dri_social" class="form-label-edit d-block mb-2">Nro. Identificación (Social) *</label>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <i class="pi pi-info-circle"></i>
        </span>
        <input
          id="dri_social"
          type="text"
          pInputText
          formControlName="dri_social"
          placeholder="Identificación del conductor"
          class="largeInput"
        />
      </div>
      @if (
        formConductor.controls["dri_social"].hasError("required") &&
        formConductor.controls["dri_social"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Campo Requerido</span>
      }
    </div>

    <!-- Direccion -->
    <div class="mb-3">
      <label for="dri_address" class="form-label-edit d-block mb-2">Dirección *</label>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <i class="pi pi-map-marker"></i>
        </span>
        <input
          id="dri_address"
          type="text"
          pInputText
          formControlName="dri_address"
          placeholder="Dirección domiciliaria"
          class="largeInput"
        />
      </div>
      @if (
        formConductor.controls["dri_address"].hasError("required") &&
        formConductor.controls["dri_address"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Campo Requerido</span>
      }
    </div>

    <!-- Password -->
    <div class="mb-3">
      <label for="dri_password" class="form-label-edit d-block mb-2">Contraseña *</label>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <i class="pi pi-key"></i>
        </span>
        <input
          id="dri_password"
          type="text"
          pInputText
          formControlName="dri_password"
          placeholder="Contraseña del app"
          class="largeInput"
        />
      </div>
      @if (
        formConductor.controls["dri_password"].hasError("required") &&
        formConductor.controls["dri_password"].touched
      ) {
        <span class="text-danger labelError"><i class="pi pi-exclamation-triangle"></i> Campo Requerido</span>
      }
    </div>

    <!-- Terminos y Condiciones -->
    <div class="d-flex align-items-center gap-3 mb-4 mt-2">
      <p-checkbox id="dri_term_conditions" formControlName="dri_term_conditions" [binary]="true" />
      <label for="dri_term_conditions" class="form-label-edit m-0">Acepta Términos y Condiciones</label>
    </div>

    <!-- Botones footer del diálogo -->
    <div class="d-flex justify-content-end gap-2 border-top pt-3">
      <p-button
        label="Cancelar"
        severity="secondary"
        [rounded]="true"
        [text]="true"
        (onClick)="dialogEdit = false"
      />
      <p-button 
        label="Guardar" 
        severity="success"
        [rounded]="true"
        [disabled]="formConductor.invalid"
        (onClick)="save()" 
      />
    </div>
  </form>
</p-dialog>
